<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="1200px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t("Edit Sale Return's information") }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="title no-select pb-1">
              <v-layout>{{ $t('Sale Information') }}</v-layout>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <v-layout row wrap justify-content-end>
                  <v-flex xs4 class="pb-3">
                    <div class="caption no-select">{{ $t('Bill Number') }}</div>
                    <strong>{{ saleData.bill_auto_number || '-' }}</strong>
                  </v-flex>
                  <v-flex xs4 class="pb-3">
                    <div class="caption no-select">{{ $t('Customer') }}</div>
                    <strong>{{ saleData.customer_name || '-' }}</strong>
                  </v-flex>
                  <v-flex xs3 class="pb-3">
                    <div class="caption no-select">{{ $t('Bill Date') }}</div>
                    <strong v-if="saleData.bill_date">{{ saleData.bill_date }}</strong>
                    <strong v-else>{{ '-' }}</strong>
                  </v-flex>
                  <v-flex xs3 class="pb-3">
                    <div class="caption no-select">
                      {{ `${$t('Total Amount')} (${systemCurrency})` }}
                    </div>
                    <strong>{{ saleData.total_amount | currency }}</strong>
                  </v-flex>
                  <v-flex xs3 class="pb-3">
                    <div class="caption no-select">
                      {{ `${$t('Net Amount')} (${systemCurrency})` }}
                    </div>
                    <strong>{{ saleData.net_amount | currency }}</strong>
                  </v-flex>
                  <v-flex xs3 class="pb-3">
                    <div class="caption no-select">{{ $t('Discount') }}</div>
                    <strong>{{ saleData.discount | percentage }}</strong>
                  </v-flex>

                  <v-flex xs12 class="title no-select pb-1">
                    <hr style="margin: 10px 0px" />
                    <v-layout>{{ $t('Return Sale Information') }}</v-layout>
                  </v-flex>

                  <v-flex xs4 sm4 class="pa-2">
                    <v-menu v-model="returnDateMenu" full-width max-width="290" :close-on-content-click="false">
                      <v-text-field
                        slot="activator"
                        :value="updateReturnForm.return_date"
                        :label="`${$t('Return Date')} *`"
                        prepend-inner-icon="event"
                        box
                        readonly
                        hide-details
                        name="Bill Date"
                        background-color="white"
                        autocomplete="off"
                        :error="errors.has('Return Date')"
                        v-validate="'required|date_format:yyyy-MM-dd'"
                      />
                      <v-date-picker @change="returnDateMenu = false" v-model="updateReturnForm.return_date" />
                    </v-menu>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 style="margin-top: 20px">
                <v-layout row wrap class="form-table-header">
                  <v-flex class="form-table-content">
                    <v-layout row>
                      <v-flex xs2 pa-2>#</v-flex>
                      <v-flex xs10 pa-2>{{ $t('Product') }}</v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs8 class="form-table-content">
                    <v-layout row>
                      <v-flex pa-2 v-if="hasCollection">{{ $t('Collections') }}</v-flex>
                      <v-flex pa-2>{{ $t('Sold Quantity') }}</v-flex>
                      <v-flex pa-2>{{ $t('Returned Quantity') }}</v-flex>
                      <v-flex pa-2>{{ $t('Sold Price') }}</v-flex>
                      <v-flex pa-2>{{ $t('Return Quantity') }}</v-flex>
                      <v-flex pa-2>{{ `${$t('Return Price')} (${systemCurrency})` }}</v-flex>
                      <v-flex pa-2>{{ `${$t('Total')} (${systemCurrency})` }}</v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs1 class="pa-2 form-table-content">{{ $t('Action') }}</v-flex>
                </v-layout>

                <template v-if="rowNumbers > 0">
                  <v-layout row wrap v-for="(row, index) in rowNumbers" :key="index">
                    <v-flex>
                      <v-layout row>
                        <v-flex xs2 class="pa-1" style="text-align: center; margin-top: 20px; font-size: 16px">{{
                          index + 1
                        }}</v-flex>
                        <v-flex xs10 class="pa-1">
                          <v-text-field
                            v-model="updateReturnForm.product_name[index]"
                            :label="`${$t('Product')} *`"
                            hide-details
                            box
                            readonly
                            :data-vv-name="'Product' + (index + 1)"
                            background-color="white"
                            :error="errors.has('Product' + (index + 1))"
                            v-validate="'required'"
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs8>
                      <v-layout row>
                        <v-flex pa-1 v-if="hasCollection">
                          <v-text-field
                            v-model.number="updateReturnForm.collection_name[index]"
                            :label="$t('Collections')"
                            hide-details
                            box
                            readonly
                            :data-vv-name="'collections' + (index + 1)"
                            background-color="white"
                            :error="errors.has('collections' + (index + 1))"
                          />
                        </v-flex>
                        <v-flex class="pa-1">
                          <v-text-field
                            v-model.number="updateReturnForm.sale_quantity[index]"
                            :label="`${$t('Sale Quantity')} *`"
                            hide-details
                            box
                            readonly
                            :data-vv-name="'Sale Quantity' + (index + 1)"
                            background-color="white"
                            :error="errors.has('Sale Quantity' + (index + 1))"
                            v-validate="'required|decimal:3'"
                            data-vv-delay="1000"
                          />
                        </v-flex>
                        <v-flex pa-1>
                          <v-text-field
                            v-model.number="updateReturnForm.returned_quantity[index]"
                            :label="`${$t('Returned Quantity')} *`"
                            hide-details
                            box
                            readonly
                            :data-vv-name="'Returned Quantity' + (index + 1)"
                            background-color="white"
                            :error="errors.has('Returned Quantity' + (index + 1))"
                            v-validate="'required|decimal:3'"
                            data-vv-delay="1000"
                          />
                        </v-flex>
                        <v-flex class="pa-1">
                          <v-text-field
                            v-model.number="updateReturnForm.sale_price[index]"
                            :label="`${$t('Sale Price')} *`"
                            hide-details
                            box
                            readonly
                            :data-vv-name="'Sale Price' + (index + 1)"
                            background-color="white"
                            :error="errors.has('Sale Price' + (index + 1))"
                            v-validate="'required|decimal:3'"
                            data-vv-delay="1000"
                          />
                        </v-flex>
                        <v-flex class="pa-1">
                          <v-text-field
                            v-model.number="updateReturnForm.return_quantity[index]"
                            :label="`${$t('Return Quantity')} *`"
                            hide-details
                            box
                            :data-vv-name="'Return Quantity' + (index + 1)"
                            background-color="white"
                            :error="errors.has('Return Quantity' + (index + 1))"
                            v-validate="'required|decimal:3|between:1,' + updateReturnForm.sale_quantity[index]"
                            @input="
                              calculateTotal(
                                index,
                                updateReturnForm.return_quantity[index],
                                updateReturnForm.return_price[index]
                              )
                            "
                            data-vv-delay="1000"
                          />
                        </v-flex>
                        <v-flex class="pa-1">
                          <v-text-field
                            v-model.number="updateReturnForm.return_price[index]"
                            :label="`${$t('Return Price')} *`"
                            hide-details
                            box
                            :data-vv-name="'Return Price' + (index + 1)"
                            background-color="white"
                            :error="errors.has('Return Price' + (index + 1))"
                            v-validate="'required|min_value:0|decimal:3'"
                            @input="
                              calculateTotal(
                                index,
                                updateReturnForm.return_quantity[index],
                                updateReturnForm.return_price[index]
                              )
                            "
                            data-vv-delay="1000"
                          />
                        </v-flex>
                        <v-flex class="pa-1">
                          <v-text-field
                            v-model.number="updateReturnForm.total[index]"
                            :label="`${$t('Total')} *`"
                            hide-details
                            box
                            readonly
                            background-color="white"
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs1 class="pa-3" style="text-align: center">
                      <v-tooltip top>
                        <v-btn label flat @click="removeRow(index)" small slot="activator" icon color="error">
                          <v-icon>delete</v-icon>
                        </v-btn>
                        <span>{{ $t('Remove this row') }}</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </template>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :disabled="rowNumbers < 1" :loading="btnReturnLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      btnReturnLoading: false,
      returnDateMenu: false,
      rowNumbers: 0,
      saleData: {
        bill_auto_number: '',
        customer_name: '',
        bill_date: '',
        total_amount: '',
        net_amount: '',
        discount: ''
      },
      updateReturnForm: {
        sale_return_id: '',
        sale_id_fk: 0,
        return_date: '',
        product_id_fk: [],
        product_name: [],
        collection_id_fk: [],
        collection_name: [],
        collection_quantity: [],
        sale_detail_id_fk: [],
        sale_quantity: [],
        returned_quantity: [],
        return_quantity: [],
        sale_price: [],
        return_price: [],
        total: []
      }
    }
  },

  computed: {
    ...mapGetters({
      saleReturnInfo: 'salesReturns/getSaleReturnInfo',
      settings: 'configurations/getSystemSettings'
    }),
    hasCollection() {
      return this.settings.production_collections === 'Active'
    }
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.rowNumbers = this.saleReturnInfo.data_detail.length
          this.saleData.customer_name = this.saleReturnInfo.data.customer_name
          this.saleData.bill_auto_number = this.saleReturnInfo.data.bill_auto_number
          this.updateReturnForm.sale_id_fk = Number(this.saleReturnInfo.data.sale_id_fk)
          this.updateReturnForm.sale_return_id = Number(this.saleReturnInfo.data.sale_return_id)
          this.updateReturnForm.return_date = this.saleReturnInfo.data.return_date

          this.updateReturnForm.product_id_fk = []
          this.updateReturnForm.product_name = []
          this.updateReturnForm.collection_id_fk = []
          this.updateReturnForm.collection_name = []
          this.updateReturnForm.collection_quantity = []
          this.updateReturnForm.sale_detail_id_fk = []
          this.updateReturnForm.sale_quantity = []
          this.updateReturnForm.returned_quantity = []
          this.updateReturnForm.return_quantity = []
          this.updateReturnForm.sale_price = []
          this.updateReturnForm.return_price = []
          this.updateReturnForm.total = []

          this.saleReturnInfo.data_detail.forEach((c, index) => {
            this.updateReturnForm.product_id_fk.push(Number(c.product_id))
            this.updateReturnForm.product_name.push(c.product_name)
            this.updateReturnForm.collection_id_fk.push(c.collection_id_fk)
            this.updateReturnForm.collection_name.push(c.collection_name)
            this.updateReturnForm.collection_quantity.push(c.collection_quantity)
            if (this.updateReturnForm.collection_name[index]) {
              this.updateReturnForm.sale_quantity.push(c.return_collection_quantity)
              this.updateReturnForm.sale_price.push(c.return_collection_price)
              this.updateReturnForm.return_price.push(c.return_collection_price)
              this.updateReturnForm.return_quantity.push(c.return_collection_quantity)
              this.updateReturnForm.returned_quantity.push(c.returned_collection_quantity)
              this.updateReturnForm.total.push(c.total_collection)
            } else {
              this.updateReturnForm.sale_quantity.push(c.return_quantity)
              this.updateReturnForm.sale_price.push(c.return_price)
              this.updateReturnForm.return_price.push(c.return_price)
              this.updateReturnForm.total.push(c.total)
              this.updateReturnForm.returned_quantity.push(c.returned_quantity)
              this.updateReturnForm.return_quantity.push(c.return_quantity)
            }
            this.updateReturnForm.sale_detail_id_fk.push(Number(c.sale_detail_id))
          })

          if (this.saleReturnInfo !== null) {
            this.addEscKeyListener()
          }
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateSaleReturnInfo: 'salesReturns/updateSaleReturnInfo'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the 'ESC' button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    removeRow(index) {
      this.rowNumbers = this.rowNumbers - 1
      this.updateReturnForm.product_id_fk.splice(index, 1)
      this.updateReturnForm.product_name.splice(index, 1)
      this.updateReturnForm.collection_id_fk.splice(index, 1)
      this.updateReturnForm.collection_name.splice(index, 1)
      this.updateReturnForm.collection_quantity.splice(index, 1)
      this.updateReturnForm.sale_detail_id_fk.splice(index, 1)
      this.updateReturnForm.sale_quantity.splice(index, 1)
      this.updateReturnForm.return_quantity.splice(index, 1)
      this.updateReturnForm.sale_price.splice(index, 1)
      this.updateReturnForm.return_price.splice(index, 1)
      this.updateReturnForm.total.splice(index, 1)
    },

    calculateTotal(index, quantity, thePrice) {
      let qtt = 0
      let price = 0
      let sumPrice = 0

      if (!isNaN(quantity)) {
        qtt = quantity
      }
      if (!isNaN(thePrice)) {
        price = thePrice
      }

      sumPrice = qtt * price
      sumPrice = Number(sumPrice)
      this.updateReturnForm.total[index] = sumPrice.toFixed(2)
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnReturnLoading = true
            let formData = new FormData(event.target)
            formData.append('sale_id_fk', this.updateReturnForm.sale_id_fk)
            formData.append('return_date', this.updateReturnForm.return_date)

            this.updateReturnForm.product_id_fk.forEach((p, index) => {
              formData.append('product_id_fk[' + [index] + ']', p)
              formData.append('collection_id_fk[' + [index] + ']', this.updateReturnForm.collection_id_fk[index] || '')
              if (this.updateReturnForm.collection_id_fk[index]) {
                formData.append(
                  'return_collection_quantity[' + index + ']',
                  this.updateReturnForm.return_quantity[index]
                )
                formData.append('return_collection_price[' + index + ']', this.updateReturnForm.return_price[index])
                formData.append(
                  'return_quantity[' + index + ']',
                  (
                    this.updateReturnForm.return_quantity[index] * this.updateReturnForm.collection_quantity[index]
                  ).toFixed(2)
                )
                formData.append(
                  'return_price[' + index + ']',
                  (
                    this.updateReturnForm.return_price[index] / this.updateReturnForm.collection_quantity[index]
                  ).toFixed(2)
                )
              } else {
                formData.append('return_collection_quantity[' + index + ']', '')
                formData.append('return_collection_price[' + index + ']', '')
                formData.append('return_quantity[' + index + ']', this.updateReturnForm.return_quantity[index])
                formData.append('return_price[' + index + ']', this.updateReturnForm.return_price[index])
              }
            })

            this.updateReturnForm.sale_detail_id_fk.forEach((p, index) => {
              formData.append('sale_detail_id_fk[' + [index] + ']', p)
            })

            let payload = {
              id: this.updateReturnForm.sale_return_id,
              formData
            }

            this.updateSaleReturnInfo(payload)
              .then(() => {
                this.btnReturnLoading = false
                this.$emit('updated')
              })
              .catch(() => {
                this.btnReturnLoading = false
              })
          }
        })
        .catch(() => {
          this.btnReturnLoading = false
        })
    }
  }
}
</script>

<style scoped />
